import * as React from 'react';
import { connect } from 'react-redux';

import { ILocation } from '../../../api/locations';
import { IAppState, Dispatch } from '../../../common/state';
import {
  applySelectedLocation,
  closeLocationSwitcher,
  selectCity,
  selectCountry,
  selectRegion,
} from '../../state/location_switcher';
import { LocationSwitherAutocompleteContainer } from '../location_switcher_autocomplete/container';
import { LocationSwither } from './index';

const LocationSwitherContainer = connect(
  (state: IAppState) => {
    return {
      autocomplete: (<LocationSwitherAutocompleteContainer />) as React.ReactNode,
      selectedRegion: state.filters.locationSwitcher.selectedRegion,
      selectedCity: state.filters.locationSwitcher.selectedCity,
      isDataLoading: state.filters.locationSwitcher.isCitiesLoading,
      regions: state.filters.regions,
      cities: state.filters.locationSwitcher.cities,
      jsonQueryUrl: state.filters.jsonQueryUrl,
    };
  },
  (dispatch: Dispatch) => ({
    applySelectedLocation: () => {
      dispatch(applySelectedLocation());
    },
    onCountrySelected: () => {
      dispatch(selectCountry());
    },
    onRegionSelected: (region: ILocation | 'moscow_mo' | 'spb_lo') => {
      dispatch(selectRegion(region));
    },
    onCitySelected: (city: ILocation) => {
      dispatch(selectCity(city));
    },
    onClose: () => {
      dispatch(closeLocationSwitcher());
    },
  }),
)(LocationSwither);

// tslint:disable-next-line:no-default-export
export default LocationSwitherContainer;
